<div class="dial-container">
  <p-speedDial [model]="sideDialItems" direction="up" [transitionDelay]="80" showIcon="pi pi-bars" hideIcon="pi pi-times" [radius]="2"></p-speedDial>
</div>
<app-activity-log [expandEvent]="openLog"></app-activity-log>
<app-main-chat [expandEvent]="openChat"></app-main-chat>
